
import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nombre: '',
    institucion: '',
    email: '',
    telefono: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [showMap, setShowMap] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const body = new URLSearchParams({
        nombre: formData.nombre,
        institucion: formData.institucion,
        email: formData.email,
        telefono: formData.telefono,
        mensaje: formData.mensaje,
      });

      const res = await fetch('https://readdy.ai/api/form/d6hrb7dpk1ctp7d9b88g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      if (!res.ok) throw new Error('Error al enviar');

      setSubmitStatus('success');
      setFormData({ nombre: '', institucion: '', email: '', telefono: '', mensaje: '' });
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <section id="contacto" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-[#1A1A2E] to-[#2D2D44] rounded-3xl shadow-2xl p-6 md:p-12 text-center mb-16 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-80 h-80 bg-[#0D9488]/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#F59E0B]/10 rounded-full blur-3xl"></div>
          <div className="relative">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-3 md:mb-4">
              ¿Listo para Optimizar tus Evaluaciones?
            </h2>
            <p className="text-base md:text-xl text-white/80 mb-6 md:mb-8 max-w-2xl mx-auto">
              Solicita una cotización personalizada y descubre cómo podemos ayudarte
            </p>
            <button
              onClick={() => document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-[#F59E0B] to-[#D97706] text-white px-6 md:px-10 py-3 md:py-4 rounded-full font-bold text-base md:text-lg hover:shadow-xl hover:shadow-[#F59E0B]/30 transition-all inline-flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              Solicitar Cotización Ahora
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#0D9488]/10 px-5 py-2 rounded-full mb-4">
              <i className="ri-mail-send-line text-[#0D9488]"></i>
              <span className="text-[#0D9488] font-semibold text-sm">Escríbenos</span>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-[#1A1A2E] mb-6">
              Contáctanos Directamente
            </h3>
            <p className="text-gray-500 mb-8 leading-relaxed text-sm md:text-base">
              Completa el formulario y nos pondremos en contacto contigo en menos de 24 horas para brindarte una solución personalizada.
            </p>

            <form
              id="contact-form"
              onSubmit={handleSubmit}
              data-readdy-form
              className="space-y-5"
            >
              <div>
                <label htmlFor="nombre" className="block text-sm font-semibold text-[#1A1A2E] mb-2">
                  Nombre Completo *
                </label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#0D9488] focus:outline-none transition-colors text-sm"
                  placeholder="Tu nombre completo"
                />
              </div>

              <div>
                <label htmlFor="institucion" className="block text-sm font-semibold text-[#1A1A2E] mb-2">
                  Institución *
                </label>
                <input
                  type="text"
                  id="institucion"
                  name="institucion"
                  value={formData.institucion}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#0D9488] focus:outline-none transition-colors text-sm"
                  placeholder="Nombre de tu institución"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-[#1A1A2E] mb-2">
                  Correo Electrónico *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#0D9488] focus:outline-none transition-colors text-sm"
                  placeholder="tu@email.com"
                />
              </div>

              <div>
                <label htmlFor="telefono" className="block text-sm font-semibold text-[#1A1A2E] mb-2">
                  Teléfono *
                </label>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#0D9488] focus:outline-none transition-colors text-sm"
                  placeholder="+51 999 999 999"
                />
              </div>

              <div>
                <label htmlFor="mensaje" className="block text-sm font-semibold text-[#1A1A2E] mb-2">
                  Mensaje *
                </label>
                <textarea
                  id="mensaje"
                  name="mensaje"
                  value={formData.mensaje}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#0D9488] focus:outline-none transition-colors resize-none text-sm"
                  placeholder="Cuéntanos sobre tus necesidades..."
                ></textarea>
                <p className="text-xs text-gray-400 mt-1">{formData.mensaje.length}/500 caracteres</p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-[#0D9488] to-[#0F766E] text-white px-8 py-4 rounded-full font-bold text-lg hover:shadow-xl hover:shadow-[#0D9488]/30 transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
              </button>

              {submitStatus === 'success' && (
                <div className="bg-[#0D9488]/10 border border-[#0D9488]/30 text-[#0D9488] px-4 py-3 rounded-lg text-sm font-medium">
                  <i className="ri-check-double-line mr-2"></i>
                  ¡Mensaje enviado exitosamente! Nos pondremos en contacto pronto.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm font-medium">
                  <i className="ri-error-warning-line mr-2"></i>
                  Hubo un error al enviar el mensaje. Por favor, intenta nuevamente.
                </div>
              )}
            </form>
          </div>

          <div className="space-y-8">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#1A1A2E] mb-6">
                Información de Contacto
              </h3>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#0D9488]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-xl text-[#0D9488]"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-[#1A1A2E] mb-1 text-sm md:text-base">Correo Electrónico</p>
                    <p className="text-gray-500 text-xs md:text-sm">fa.digital.omr@gmail.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#F59E0B]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-xl text-[#F59E0B]"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-[#1A1A2E] mb-1 text-sm md:text-base">Teléfono</p>
                    <p className="text-gray-500 text-xs md:text-sm">979657270 - 999225504</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div
                    className="w-12 h-12 bg-[#0D9488]/10 rounded-2xl flex items-center justify-center flex-shrink-0 cursor-pointer hover:bg-[#0D9488]/20 transition-colors"
                    onClick={() => setShowMap(true)}
                    title="Ver mapa de Lambayeque"
                  >
                    <i className="ri-map-pin-line text-xl text-[#0D9488]"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-[#1A1A2E] mb-1 text-sm md:text-base">Ubicación</p>
                    <p
                      className="text-[#0D9488] text-xs md:text-sm cursor-pointer hover:underline"
                      onClick={() => setShowMap(true)}
                    >
                      Lambayeque - Perú
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#F59E0B]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-xl text-[#F59E0B]"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-[#1A1A2E] mb-1 text-sm md:text-base">Horario de Atención</p>
                    <p className="text-gray-500 text-xs md:text-sm">Lunes a Viernes: 9:00 AM - 6:00 PM</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#0D9488]/10 to-[#0D9488]/5 rounded-2xl p-6 md:p-8 border border-[#0D9488]/10">
              <h4 className="text-lg md:text-xl font-bold text-[#1A1A2E] mb-4">
                ¿Necesitas ayuda inmediata?
              </h4>
              <p className="text-gray-500 mb-6 text-xs md:text-sm">
                Contáctanos por WhatsApp y te responderemos al instante
              </p>
              <a
                href="https://wa.me/51979657270"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-2 bg-[#25D366] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#20BA5A] transition-all whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                Chatear en WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Modal del mapa */}
      {showMap && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
          onClick={() => setShowMap(false)}
        >
          <div
            className="bg-white rounded-2xl overflow-hidden shadow-2xl w-full max-w-2xl mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-gradient-to-r from-[#0D9488] to-[#0F766E] px-5 py-4 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-map-2-line text-white text-lg"></i>
                </div>
                <span className="text-white font-semibold text-sm">Nuestra Ubicación — Lambayeque, Perú</span>
              </div>
              <button
                onClick={() => setShowMap(false)}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-white text-lg"></i>
              </button>
            </div>
            <div className="w-full h-96">
              <iframe
                title="Mapa Lambayeque - F&A Digital"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d63180.45!2d-79.9062!3d-6.7011!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x904cef2b5b5b5b5b%3A0x0!2sLambayeque%2C+Per%C3%BA!5e0!3m2!1ses!2spe!4v1700000000000!5m2!1ses!2spe&q=Lambayeque,Peru"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="bg-white px-5 py-3 flex items-center justify-between">
              <span className="text-gray-500 text-xs">Lambayeque, Región Lambayeque, Perú</span>
              <a
                href="https://maps.google.com/?q=Lambayeque,Peru"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-1 text-[#0D9488] text-xs font-semibold hover:underline cursor-pointer whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-external-link-line text-sm"></i>
                </div>
                Ver en Google Maps
              </a>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
